import { Input } from '@cian/ui-kit';
import classNames from 'classnames';
import { Field } from 'formik';
import * as React from 'react';

import { Label } from './Label';
import { useFieldHasErrors } from './utils';
import * as styles from '../index.css';

export const Phone = () => {
  const invalid = useFieldHasErrors('phone');

  return (
    <div className={classNames(styles['field'])}>
      <Label invalid={invalid}>Телефон для связи</Label>
      <div className={styles['phone-input-container']}>
        <Field name="phone" as={Input} custom={{ invalid, size: 'XS', leftAdornment: '+7' }} />
      </div>
    </div>
  );
};
